/* eslint-disable */

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE';
export const PROD_CATALOG = 'PROD_CATALOG';
export const SET_CAR_IMAGES = 'SET_CAR_IMAGES';
export const SET_NEXT_IMAGES = 'SET_NEXT_IMAGES';
export const SET_PRE_IMAGES = 'SET_NEXT_IMAGES';

export const ADYEN_CONFIG = 'ADYEN_CONFIG';
export const ADYEN_PAYMENT_TYPE = 'ADYEN_PAYMENT_TYPE';
export const ADYEN_PAYMENT_METHODS = 'ADYEN_PAYMENT_METHODS';
export const ADYEN_PAYMENT_RESPONSE = 'ADYEN_PAYMENT_RESPONSE';
export const ADYEN_PAYMENT_DETAILS_RESPONSE = 'ADYEN_PAYMENT_DETAILS_RESPONSE';
export const ADYEN_SELECTED_STORED_PAYMENT_METHOD =
  'ADYEN_SELECTED_STORED_PAYMENT_METHOD';
export const CAPTCHA_TOKEN = 'CAPTCHA_TOKEN';
export const ACCOUNT_DETAILS = 'ACCOUNT_DETAILS';
export const COUNTRY_LIST = 'COUNTRY_LIST';
export const SELECTED_COUNTRY = 'SELECTED_COUNTRY';
export const CAPTCHA_KEY = 'CAPTCHA_KEY';
export const ADYEN_RESET = 'ADYEN_RESET';
export const PROD_BILLING = 'PRODUCT_BILLING';
export const ORDER_INFO = 'ORDER_INFO';
export const MAKE_ACTIVE = 'MAKE_ACTIVE';
export const DEACTIVATE_ALL = 'DEACTIVATE_ALL';
export const ANIMATE_TAG = 'ANIMATE_TAG';
export const GET_TECH_SPECS_DATA = 'GET_TECH_SPECS_DATA';
export const GET_APP_DATA = 'GET_APP_DATA';
export const PROD_ORDERID = 'PRODUCT_ORDERID';
export const TRANSACTION_HASH = 'TRANSACTION_HASH';
export const GET_ADDRESS = 'GET_ADDRESS';
export const GET_AUTO_ADDRESS = 'GET_AUTO_ADDRESS';
export const SET_VARIANT = 'SET_VARIANT';

export const RESERVE_CTA_FLOW = "RESERVE_CTA_FLOW"

export const PAYMENT_METADATA = 'PAYMENT_METADATA';
export const PAYMENT_SHOW_SAVED_CARDS = 'PAYMENT_SHOW_SAVED_CARDS';
export const PAYU_PAYMENT_METHODS = 'PAYU_PAYMENT_METHODS';
export const PAYU_SAVED_CARDS = 'PAYU_SAVED_CARDS';
export const PAYU_NETBANKING_LIST = 'PAYU_NETBANKING_LIST';
export const PAYU_SAVED_CARD_INFO = 'PAYU_SAVED_CARD_INFO';
export const PAYU_ARE_CARDS_SAVED = 'PAYU_ARE_CARDS_SAVED';
export const USER_DETAILS = 'USER_DETAILS';
export const ORDER_DETAILS = "ORDER_DETAILS";
export const SET = 'SET';
export const SET_STATIC_IMAGE = 'SET_STATIC_IMAGE';
export const SET_IP_BASED_CODE = 'SET_IP_BASED_CODE';

export const FROM_LOCATION = 'FROM LOCATION';
export const SAVED_CARDS_EXISTS = 'SAVED_CARDS_EXISTS';
export const SET_OEM_SESSION_ID = 'SET_OEM_SESSION_ID';
export const SET_OEM_USER_ID = 'SET_OEM_USER_ID';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PHONENUMBER = 'SET_PHONENUMBER';
export const SET_LAT = "SET_LAT";
export const SET_LNG = "SET_LNG";
export const SET_SOURCEFROMAPP = "SET_SOURCEFROMAPP";
export const SET_OSNAME = "SET_OSNAME";
export const SET_OSVERSION = "SET_OSVERSION";
export const SET_APPNAME = "SET_APPNAME";
export const SET_APPVERSION = "SET_APPVERSION";
export const SET_COUNTRYCODE = "SET_COUNTRYCODE";
export const SET_DEVICEMODEL = "SET_DEVICEMODEL";
export const SET_DEVICEBRAND = "SET_DEVICEBRAND";
export const SET_DEVICEMANUFACTURER = "SET_DEVICEMANUFACTURER";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_OEMPLATFORM = "SET_OEMPLATFORM";
export const SET_NETWORKTYPE = "SET_NETWORKTYPE";
export const SET_OLANEWUSER = "SET_OLANEWUSER";
export const SET_OEMNEWUSER = "SET_OEMNEWUSER";
export const SET_CITY = "SET_CITY";
export const SET_STATE = "SET_STATE";
export const SET_BROWSERNAME = "SET_BROWSERNAME";
export const SET_BROWSERVERSION = "SET_BROWSERVERSION";
export const SET_DEVICETYPE = "SET_DEVICETYPE";
export const SET_SCREENDPI = "SET_SCREENDPI";
export const SET_SCREENWIDTH = "SET_SCREENWIDTH";
export const SET_SCREENHEIGHT = "SET_SCREENHEIGHT";
export const SET_DEVICEID = "SET_DEVICEID";
export const SET_FULLNAME = "SET_FULLNAME";
export const SET_SIGNUP_NEW_USER = "SET_SIGNUP_NEW_USER";
export const SET_FUNNELTRACKERID = "SET_FUNNELTRACKERID";
export const SET_ANALYTICSGLOBALDATAREADY = "SET_ANALYTICSGLOBALDATAREADY";
